/**
 * Lista de extensiones del editor.
 *
 * Vive separada del componente para que los tests construyan exactamente el
 * mismo schema que monta el editor: si una content expression referencia un
 * nodo que no está registrado, el schema lanza al construirse y el test lo
 * detecta antes de llegar a producción.
 */

import StarterKit from "@tiptap/starter-kit";
import Image from "@tiptap/extension-image";
import Link from "@tiptap/extension-link";
import Underline from "@tiptap/extension-underline";
import { Table } from "@tiptap/extension-table";
import TableRow from "@tiptap/extension-table-row";
import TableHeader from "@tiptap/extension-table-header";
import TableCell from "@tiptap/extension-table-cell";
import { FaqItem, FaqList } from "./extensions";

export function buildEditorExtensions() {
  return [
    StarterKit.configure({
      heading: { levels: [2, 3] },
      link: false,
      underline: false,
    }),
    Link.configure({ openOnClick: false, protocols: ["http", "https", "mailto", "tel"] }),
    Underline,
    Image.configure({ allowBase64: false, inline: false }),
    Table.configure({ resizable: true }),
    TableRow,
    TableHeader,
    TableCell,
    // `FaqItem` debe quedarse en el schema junto a `FaqList`: la content
    // expression `faqItem+` de `FaqList` lanza `SyntaxError` si el nodo no
    // existe cuando ProseMirror construye el schema.
    FaqItem,
    FaqList,
  ];
}
